module.exports = __webpack_public_path__ + "img/Casino_Close.37fa8788.png";